/** Format USD amounts for display (SpectraI billing). */
export function formatUsd(amount: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function formatUsdWhole(amount: number): string {
  return `$${amount.toLocaleString('en-US')}`
}
